import { render } from "./page-media.vue?vue&type=template&id=6f6ec400"
import script from "./page-media.vue?vue&type=script&lang=js"
export * from "./page-media.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__